interface ProjectMetric {
  value: string
  label: string
  description?: string
}

interface ProjectMetricsProps {
  metrics: ProjectMetric[]
}

export function ProjectMetrics({ metrics }: ProjectMetricsProps) {
  if (!metrics || metrics.length === 0) return null

  return (
    <div className="my-8">
      <h2 className="mb-6 text-2xl font-semibold">Key Metrics</h2>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {metrics.map((metric, index) => (
          <div key={index} className="bg-primary/5 border-primary/20 rounded-lg border p-6 text-center">
            <div className="text-primary mb-2 text-4xl font-bold">{metric.value}</div>
            <div className="mb-2 text-lg font-semibold">{metric.label}</div>
            {metric.description && <div className="text-muted-foreground text-sm">{metric.description}</div>}
          </div>
        ))}
      </div>
    </div>
  )
}
